import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.jhatkabytes.com";

const setMetaTag = (attr: "name" | "property", key: string, content: string) => {
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

// Sets the page title, description and canonical URL so each page is indexed on its own.
function usePageMeta(title: string, description?: string, noindex = false) {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title;
    setMetaTag("name", "robots", noindex ? "noindex, follow" : "index, follow");
    setMetaTag("property", "og:title", title);
    if (description) {
      setMetaTag("name", "description", description);
      setMetaTag("property", "og:description", description);
    }

    const url = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
    setMetaTag("property", "og:url", url);
  }, [title, description, pathname, noindex]);
}

export default usePageMeta;
